import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import DataTable from './shared/DataTable';
import 'moment-timezone';
import { observer } from "mobx-react";

const styles = theme => ({
  button: {
    margin: theme.spacing.unit,
  },
  leftIcon: {
    marginRight: theme.spacing.unit,
  },
  rightIcon: {
    marginLeft: theme.spacing.unit,
  },
  iconSmall: {
    fontSize: 20,
  },
});

class Products extends Component {

  constructor(props) {
    super(props);
    this._validAuthStates = ['signedIn'];

    this.state = {
      searchTerm: ""
    }

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSearchInputChange = this.handleSearchInputChange.bind(this);
  }

  componentDidMount() {
    this.props.productStore.getProductList();
  }

  addProduct() {
    this.props.productStore.addProduct();
  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    this.setState({
      [name]: value
    });
  }

  componentWillUnmount() {
    clearTimeout(this.searchTimeout);
  }

  handleSearchInputChange(event) {
    this.props.productStore.searchTerm = event.target.value;

    /* Only search once the user stops typing */
    clearTimeout(this.searchTimeout);
    this.searchTimeout = setTimeout(() => this.props.productStore.searchProduct(), 300);
  }

  render() {
    const { classes } = this.props;

    return (
      <Grid container>
        <Grid item >
          <TextField
              id="searchTerm"
              name="searchTerm"
              label="Suchbegriff"
              type="search"
              className={classes.textField}
              margin="none"
              value={this.props.productStore.searchTerm}
              onChange={this.handleSearchInputChange} />
        </Grid>
        <Grid item>
          <Button variant="contained" size="small" color="secondary" onClick={()=>this.addProduct()} className={classes.button}>
            Produkt anlegen
          </Button>
        </Grid>
        <DataTable 
          store={this.props.productStore} 
          rows={this.props.productStore.productList} 
          columns={this.props.productStore.tableColumns}
          history={this.props.history}
        />
      </Grid>
    );
  }
}

export default withStyles(styles)(observer(Products));